// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpressSetupCopayDto
 */
export interface IExpressSetupCopayDto {
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupCopayDto
     */
    category_type?: IExpressSetupCopayDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupCopayDto
     */
    amount?: number;
}

/**
* @export
* @enum {string}
*/
export enum IExpressSetupCopayDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IExpressSetupCopayDto interface.
 */
export function instanceOfIExpressSetupCopayDto(value: object): value is IExpressSetupCopayDto {
    return true;
}

export function IExpressSetupCopayDtoFromJSON(json: any): IExpressSetupCopayDto {
    return IExpressSetupCopayDtoFromJSONTyped(json, false);
}

export function IExpressSetupCopayDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupCopayDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function IExpressSetupCopayDtoToJSON(json: any): IExpressSetupCopayDto {
    return IExpressSetupCopayDtoToJSONTyped(json, false);
}

export function IExpressSetupCopayDtoToJSONTyped(value?: IExpressSetupCopayDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category_type': value['category_type'],
        'amount': value['amount'],
    };
}

